<script>
export default {
  computed: {
    login() {
      return () => import(`@/components/Themes/${this.$cookies.get('theme') ?? 'default'}/Login`);
    }
  },
  methods: {},
};
</script>
<template>
  <component :is="login" v-if="login"></component>
</template>